/**
 * @generated SignedSource<<d3e2fdeea46c5459dee47f9d4acbf897>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type ScreenDeviceStatus = "ACTIVE" | "INACTIVE" | "REGISTERED";
import { FragmentRefs } from "relay-runtime";
export type OrgScreenListItem_screen$data = {
  readonly lastIP: string | null;
  readonly lastIPConformsToCIDR: boolean | null;
  readonly lastUsedAtDate: {
    readonly storeFormattedDate: string;
  } | null;
  readonly name: string;
  readonly status: ScreenDeviceStatus;
  readonly store: {
    readonly name: string;
    readonly " $fragmentSpreads": FragmentRefs<"OrgStoreWorkspaceBreadcrumbsWithoutExternalId_store">;
  } | null;
  readonly " $fragmentType": "OrgScreenListItem_screen";
};
export type OrgScreenListItem_screen$key = {
  readonly " $data"?: OrgScreenListItem_screen$data;
  readonly " $fragmentSpreads": FragmentRefs<"OrgScreenListItem_screen">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "OrgScreenListItem_screen",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "status",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "StoreZonedDate",
      "kind": "LinkedField",
      "name": "lastUsedAtDate",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": [
            {
              "kind": "Literal",
              "name": "style",
              "value": "DATE_ONLY"
            }
          ],
          "kind": "ScalarField",
          "name": "storeFormattedDate",
          "storageKey": "storeFormattedDate(style:\"DATE_ONLY\")"
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "lastIP",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "lastIPConformsToCIDR",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Store",
      "kind": "LinkedField",
      "name": "store",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "OrgStoreWorkspaceBreadcrumbsWithoutExternalId_store"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "StorecastScreen",
  "abstractKey": null
};
})();

(node as any).hash = "5548de2685655fe58cbf60f902aa01bf";

export default node;
